import Hunt from 'huntjs';
import { Breakpoints } from '../utils/breakpoints';

export const SetupInViewDetection = (application) => {
  const els = document.querySelectorAll('.-detect-in-viewport');

  const bp = new Breakpoints();
  let offset = -1 * window.innerHeight / 100;
  offset *= bp.breakpointDown('md') ? 5 : 25;
  new Hunt(els, {
    offset,
    enter: (el) => {
      el.classList.add('-in-viewport');
      if (el.classList.contains('animate__animated')) {
        el.classList.add('-start-animation');
      }

      if (el.hasAttribute('data-controller')) {
        const controller = application.getControllerForElementAndIdentifier(el, el.getAttribute('data-controller'));
        if (controller && "inViewport" in controller) {
          controller.inViewport();
        }
      }

      if (el.querySelector('.main-page__group video')) {
        let video = el.querySelector('.main-page__group video');
        video.pause();
        video.currentTime = 0;
        video.play();
      }
    },
  });
};